// extracted by mini-css-extract-plugin
export default {"mobileWarning":"F62jls4MFBHETMkZGZ1t","mobileWarningContents":"xtpyHQkC1CrswLPNsNjv","mobileWarningContentsIcon":"v8qVTqTKmmBWoTGSCu7t"};